import * as z from 'zod/mini'
import { emailField } from './common'

/**
 * The contact details a member of the public types into a booking form - the reservation widget and
 * the public event sign-up. Shared by the HTTP body and the forms, so both reject the same input.
 * Names and phone are trimmed; a whitespace-only value counts as empty.
 */
export const contactFields = {
  firstName: z.string().check(z.trim(), z.minLength(1), z.maxLength(255)),
  lastName: z.string().check(z.trim(), z.minLength(1), z.maxLength(255)),
  email: emailField,
  phone: z.string().check(z.trim(), z.minLength(1), z.maxLength(50)),
}

/**
 * The contact form on its own - what the public event sign-up and the reservation widget edit.
 * Both forms validate against this, and the event sign-up sends it unchanged.
 */
export const contactDetails = z.object({ ...contactFields })
export type ContactDetails = z.infer<typeof contactDetails>

export const emptyContactDetails = (): ContactDetails => ({ firstName: '', lastName: '', email: '', phone: '' })
